class PlayerBonusViewModel {
  id;
  bonus_engine_code;
  bonus_id;
  bonus_name;
  bonus_status;
  created_at;
  desc;
  expire_at;
  marketing_code;
  realized_amount;
  total_amount;
  type;
  uid;
  remaining_amount;
  release_mechanism;
  credit_type;
}
export {
  PlayerBonusViewModel
};
//# sourceMappingURL=types.js.map
